import api from './api';

export const getPageContent = async (page: string) => {
  try {
    const response = await api.get(`/pages/${page}`);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error(`An error occurred while fetching page content for ${page}.`);
  }
};

export const updatePageContent = async (page: string, content: any) => {
  try {
    const response = await api.put(`/pages/${page}`, content);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error(`An error occurred while updating page content for ${page}.`);
  }
};
